import React, {Fragment, useRef, useState} from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {resetPassword} from "../api/apiClient";
import {toast} from "react-toastify";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle, faTimesCircle} from "@fortawesome/free-solid-svg-icons";

const PasswordResetPage = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [errors, setErrors] = useState(null);
    const [password, setPassword] = useState("");
    const [passwordValidations, setPasswordValidations] = useState({
        length: false,
        letter: false,
        mixedCase: false,
        number: false,
    });
    const confirmPasswordRef = useRef(null);
    const navigate = useNavigate();

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);

        setPasswordValidations({
            length: value.length >= 8,
            letter: /[a-zA-Z]/.test(value),
            mixedCase: /[a-z]/.test(value) && /[A-Z]/.test(value),
            number: /\d/.test(value),
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const confirmPassword = confirmPasswordRef.current.value;

        // Validation
        const validationErrors = {};
        if (!password) {
            validationErrors.password = ["Das Passwort ist erforderlich."];
        }
        if (!confirmPassword) {
            validationErrors.confirmPassword = ["Die Passwortbestätigung ist erforderlich."];
        }
        if (password && confirmPassword && password !== confirmPassword) {
            validationErrors.confirmPassword = ["Die Passwörter stimmen nicht überein."];
        }

        // Set errors if any, otherwise submit
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors(null);

        resetPassword(token, password, confirmPassword)
            .then((response) => {
                toast("Passwort erfolgreich zurückgesetzt.");
                navigate("/login");
            })
            .catch((error) => {
                toast("Fehler beim Zurücksetzen des Passworts.");
            });
    };

    return <Fragment>
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center">
            <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
                <h2 className="text-2xl font-semibold text-gray-800 text-center mb-4">
                    Passwort zurücksetzen
                </h2>
                <p className="text-gray-600 text-center mb-6">
                    Bitte gib dein neues Passwort ein und bestätige es.
                </p>
                {/* Display Errors */}
                {errors && (
                    <div className="text-red-500 mb-4">
                        {Object.keys(errors).map((key) => (
                            <p key={key}>{errors[key][0]}</p>
                        ))}
                    </div>
                )}
                <form onSubmit={handleSubmit}>
                    <div>
                        <label
                            htmlFor="password"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Neues Passwort*
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:ring-pegasusPurple focus:border-pegasusPurple"
                            placeholder="Neues Passwort"
                            onChange={handlePasswordChange}
                            requied
                        />
                    </div>
                    {/* Password Validation */}
                    <div className="mt-2 space-y-1 mb-4">
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={passwordValidations.length ? faCheckCircle : faTimesCircle}
                                className={passwordValidations.length ? "text-green-500" : "text-gray-400"}
                            />
                            <span className="ml-2 text-xs">Mindestens 8 Zeichen</span>
                        </div>
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={passwordValidations.letter ? faCheckCircle : faTimesCircle}
                                className={passwordValidations.letter ? "text-green-500" : "text-gray-400"}
                            />
                            <span className="ml-2 text-xs">Mindestens ein Buchstabe</span>
                        </div>
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={passwordValidations.mixedCase ? faCheckCircle : faTimesCircle}
                                className={passwordValidations.mixedCase ? "text-green-500" : "text-gray-400"}
                            />
                            <span className="ml-2 text-xs">Groß- und Kleinbuchstaben</span>
                        </div>
                        <div className="flex items-center">
                            <FontAwesomeIcon
                                icon={passwordValidations.number ? faCheckCircle : faTimesCircle}
                                className={passwordValidations.number ? "text-green-500" : "text-gray-400"}
                            />
                            <span className="ml-2 text-xs">Mindestens eine Zahl</span>
                        </div>
                    </div>
                    <div className="mb-6">
                        <label
                            htmlFor="confirm-password"
                            className="block text-sm font-medium text-gray-700"
                        >
                            Passwort bestätigen*
                        </label>
                        <input
                            type="password"
                            id="confirm-password"
                            ref={confirmPasswordRef}
                            className="w-full border border-gray-300 rounded-md p-2 mt-1 focus:outline-none focus:ring-pegasusPurple focus:border-pegasusPurple"
                            placeholder="Passwort bestätigen"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-pegasusPurple text-white py-2 px-4 rounded-md hover:bg-pegasusPurpleHover"
                    >
                        PASSWORT ZURÜCKSETZEN
                    </button>
                </form>
            </div>
        </div>
    </Fragment>
}

export default PasswordResetPage;